// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import type { AnswerProps, UserAnswersProps } from '../types'
import styles from './Answer.css'

type Props = {
  answer: AnswerProps,
  questionId: string,
  userAnswers: UserAnswersProps,
  onAnswerClick: (Array<string>, string, string) => void
}

export class Answer extends PureComponent<Props, {}> {
  onButtonClick = () => {
    const { onAnswerClick, answer, questionId } = this.props
    onAnswerClick(answer.sampleName, questionId, answer.id)
  }

  render() {
    const { answer, userAnswers, questionId } = this.props
    const chosenAnswer = userAnswers.find(userAnswer => userAnswer.questionId === questionId)
    const isChosen = chosenAnswer && answer.id === chosenAnswer.id
    return (
      <li>
        <button
          className={`nrk-button ${styles['answer-option']} ${isChosen ? `${styles['answer-option__selected']}` : ''}`}
          onClick={this.onButtonClick}
        >
          <span>{answer.answerText}</span>
          <div className={`${styles['selected']}`} />
        </button>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Answer.js